export default {
    ledium_title: 'Ledium MEC',
    logout_user: 'Logout {0}',

    dashboard_title: 'Dashboard',
    dashboard_description: 'This is your Project Control Center. You can start, stop, pause your growing Projects created in the Project Editor.',

    pfd_unit: 'µmol/m²/s',
    irradiance_unit: 'W/m²',
    dli: 'DLI',
    dli_unit: 'mol/m²/day',
    dli_total_unit: 'mol/m²',
    dli_current_section_day: 'Current section day',
    dli_sum_all_sections: 'Sum all sections',
    pfd: 'PFD',
    irradiance: 'Irradiance',
    intensity: 'Intensity',
    current_intensity: 'Current intensity',
    mix_intensity: 'Mix intensity:',
    original_light_recipe_intensity: 'Original Light Recipe Intensity:',

    X_bit: '{0} bit',
    bit: 'bit',
    channel_dmx_value: 'Channel DMX value',

    project_editor_title: 'Project Editor',
    project: 'Project',
    project_description: 'This is the place, where you can match your Spectrum Mixes to the original Light Recipes.',
    no_project: 'You do not have any Projects now.',
    search_for_project: 'Search for Project',
    select_recipe: 'Select Growth Recipe',
    project_running_lock: 'A running Project cannot be modified or deleted',
    project_editor_recipe_info: 'This Growth Recipe uses {0} unique Light Recipe{0,choice,0#s|1#|1<s}.',
    project_editor_missing_light_recipes:
        'The Growth Recipe does not have any Light Recipes in the Circadian settings. You are probably trying to use an unfinished Growth Recipe.',
    no_recipe_selected: 'No recipe selected',
    project_linked_spectrum_mix: 'Can not be selected, Spectrum Mix or a Lighting Device in the Spectrum Mix is used by Project "{0}"',
    project_editor_select_spectrum_mix: 'Select Spectrum mix for Light Recipe "{0}"',
    do_you_want_to_stop_the_project: 'Do you really want to stop the Project?',
    original_light_recipe: 'Original Light Recipe',
    mixed_spectrum: 'Mixed spectrum',
    value: 'Value',
    one_bit_on: 'ON',
    one_bit_off: 'OFF',
    jump_back: 'Jump back to the {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {0} section',
    jump_forward: 'Jump forward to the {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {0} section',
    restart_current_circadian: 'Restart current circadian',

    group_device_management: 'Device management',

    light_channels_title: 'My Lighting Devices',
    light_channel: 'Lighting Device',
    light_channel_description:
        'Available Lighting Devices for you. Upload, edit, remove your lighting equipments here. Lighting Device could  be a standalone luminaire, part of a LED fixture (blue LEDs in an RGBW light), or either a large inslallation,  which will be controlled separately from the others. ',
    no_light_channel: 'You do not have any Lighting Devices now.',
    search_for_light_channel: 'Search for Lighting Device',
    select_light_channel: 'Select Lighting Devices',
    light_channel_running_project: 'The Lighting Device is used by a running Project: {0}',
    light_channel_linked_project: 'The Lighting Device is used by Spectrum Mix "{0}" for Project "{1}" and can not be deleted.',
    resolution: 'Resolution',
    light_channel_details: 'DMX: {0}, {1} bit',
    intensity_value_X_to_Y: 'Relative intensity value ({0} - {1})',
    you_should_upload_a_valid_spectrogram_csv_file_before_save: 'You should upload a valid spectrogram CSV file before save.',
    test: 'Test',
    test_channel: 'Test channel',
    search_next_free_channel: 'Search next free DMX channel',
    next_free_channel_can_not_allocate: 'Can not allocate free DMX channel for {0} bit resolution!',
    next_free_channel_found: 'Found the lowest free DMX channel for {0} bit resolution.',
    dmx_channel: 'DMX Channel',
    dmx_channel_X_to_Y: 'DMX Channel ({0}-{1})',
    dmx_channel_channel_info: 'The {0} bit resolution will use {1} sequential channels (channel {2} to channel {3})',
    dmx_channel_channel_conflict:
        'There are no {0} sequential channels available, starting with channel {1}. You could use different starting channel manually of by using the "Search next free channel" button.',
    USED_IN_SPECTRUM_MIX: 'Light channel is used in {0} Spectrum Mix, group switching is not possible',

    spectrum_mixer_title: 'Spectrum Mixer',
    spectrum_mix: 'Spectrum Mix',
    spectrum_mixer_description: 'You can make a Spectrum Mix with your available Lighting Devices, which will simulate a Light Recipe.',
    no_spectrum_mix: 'You do not have any Spectrum Mixes now.',
    search_for_spectrum_mix: 'Search for Spectrum Mix',
    spectrum_mix_running_project: 'The Spectrum Mix is used by a running Project: {0}',
    spectrum_mix_linked_project: 'The Spectrum Mix is used by Project "{0}" and can not be deleted',
    spectrum_mix_linked_light_channel_another_mix:
        'Can not be selected, Lighting Device is added to "{0}" Spectrum Mix that have a Project "{1}" related Lighting Device',
    spectrum_mix_linked_light_channel_project: 'Can not be selected, Lighting Device is used by Project "{0}"',
    spectrum_mix_auto_mix: 'Auto mix',
    spectrum_mix_similarity: 'Spectral similarity',
    spectrum_mix_realtime_lights: 'Realtime lights',
    spectrum_mix_realtime_lights_forced_disable: 'Realtime lights were disabled because a Lighting Device was edited or deleted.',
    spectrum_mix_settings_list_view: 'List view',
    spectrum_mix_settings_carousel_view: 'Carousel view',
    add_new_spectrum_mix_button: 'Add new Spectrum Mix',

    detail_range: 'Range',
    detail_blue: 'Blue',
    detail_fr: 'Far Red',
    detail_green: 'Green',
    detail_ir: 'Infrared',
    detail_red: 'Red',
    detail_sum: 'Summary',
    detail_uv: 'Ultraviolet',
    detail_uvA: 'UV-A',
    detail_uvB: 'UV-B',
    detail_uvC: 'UV-C',
    detail_visibleSum: 'Visible range',
    detail_ppfd: 'PPFD',
    detail_red_blue_ratio: 'Red/Blue ratio',

    group_manage_projects: 'Manage Projects',

    recipes_title: 'Growth Recipes',
    recipe: 'Recipe',
    save_recipe: 'Save Growth Recipe',
    recipe_description:
        'Growth Recipes are based on Sections and Light Recipes. Every Section has a timeline you can place Light Recipes on. You could have unlimited number of Sections.',
    no_recipe: 'You do not have any Growth Recipes now',
    search_for_recipe: 'Search for Growth Recipe',
    recipe_linked_project: 'The Growth Recipe is used by at least one Project, can not be deleted',
    recipe_locked_project: 'The Growth Recipe is used by at least one running Project, can not be modified',
    recipe_section_saved_info: 'Section is updated, but the Growth Recipe is not saved yet!',
    add_new_section_button: 'Add new Section',
    new_section_temporary_name: 'NEW SECTION',
    add_new_light_event_button: 'Add new light event',
    delete_circadian_event_title: 'Delete circadian event',
    delete_circadian_event_message: 'Do you want to delete this circadian event?',
    event_time: 'Event: {0}:{1}',
    circadian_length_hours: 'hours',
    save_section: 'Save section',
    delete_section_title: 'Delete section',
    delete_section_message: 'Do you want to delete this section?',
    discard_section_changes_title: 'Discard changes',
    discard_section_changes_message: 'You have unsaved changes. Do you want to discard them?',
    circadian_repeat_time: 'Repeat time',
    section_timeline_info: 'The timeline is always in 24hr format, the running time will be adjusted proportionately to the circadian length.',
    circadian_length: 'Circadian length',
    select_section_background_color: 'Select color for the section',
    hours: 'Hours',

    light_recipes_title: 'Light Recipes',
    light_recipe: 'Light Recipe',
    light_recipe_description:
        'Light Recipe is a light spectrum recorded with a spectrophotometer or created by yourself. This is the theoretical fundamental of the system. You can upload or draw spectrograms here. The controller hardware will simulate these Light Recipes as good as possible with your available Lighting Devices.',
    no_light_recipe: 'You do not have any Light Recipes now.',
    search_for_light_recipe: 'Click here for search Light Recipes',
    light_recipe_running_project: 'The Light Recipe is used by at least one running Project, can not be modified',
    light_recipe_linked_project: 'The Light Recipe is used by at least one Project, can not be deleted',
    light_recipe_csv_upload_title: 'Are you sure?',
    light_recipe_csv_upload_message: 'The uploaded CSV will overwrite the existing spectrum',
    light_recipe_download_csv: 'Download Spectrogram in CSV',

    add_new_project: 'Add new Project',
    start_project: 'Start Project',
    project_started: 'Project is successfully started.',
    stop_project: 'Stop Project',
    project_stopped: 'Project is successfully stopped.',
    pause_project: 'Pause Project',
    resume_project: 'Resume Project',
    project_paused: 'Project is successfully paused.',
    project_resumed: 'Project is resumed.',
    project_detailed_status: 'Current section is {0}, {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {2} at {3}%',
    project_is_running_for: 'The Project is running for {0}',
    set_start_time: 'Set start time',
    project_is_starts_with_a_delay_within: 'The Project starts with a delay, within {0}',
    project_is_paused_at: 'Project is paused at {0}.',
    project_detailed_last_status: 'Last section was {0}, {1}{1,choice,0#th|1#st|2#nd|3#rd|3<th} circadian of {2} at {3}%',

    are_you_sure: 'Are you sure?',
    do_you_want_to_delete_X: 'Do you want to delete "{0}"?',
    do_you_want_to_duplicate_X: 'Do you want to duplicate "{0}"?',
    X_is_successfully_duplicated: '{0} is successfully duplicated',
    something_went_wrong: 'Something went wrong...',

    name: 'Name',
    add_new: 'Add new',
    view: 'View',
    edit: 'Edit',
    duplicate: 'Copy',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    ok: 'Ok',

    you_can_change_the_order_of_the_sections_by_drag_n_drop: 'You can change the order of the sections by drag & drop.',
    wave_length_intensity: 'Wavelength',
    target_wave_length_intensity: 'Original Light Recipe spectrum',
    editing_light_recipe: 'Editing Light Recipe',
    X_is_successfully_added: '{0} is successfully added',
    X_is_successfully_updated: '{0} is successfully updated',
    unable_to_save_the_data: 'Unable to save the data.',

    description: 'Description',
    no_description: 'No description',
    select_light_recipe: 'Select Light Recipe',
    no_light_recipe_selected: 'No Light Recipe selected',

    upload_csv_file: 'Upload CSV file',
    csv_file_is_successfully_uploaded: 'CSV file is successfully uploaded',
    could_not_parse_spectrogram_data_in_the_uploaded_CSV_file: 'Could not parse spectrogram data in the uploaded CSV file!',

    login_successful: 'Successfully logged in',
    logout_successful: 'Logged out',
    login_failed: 'Authentication failed',
    login_name: 'Login name',
    password: 'Password',
    sign_in: 'Sign In',

    // item errors
    spectrum_mix_not_exists: 'A paired Spectrum mix is no longer available',
    spectrum_mix_not_available: 'There is no Spectrum Mix created for a Light Recipe',
    spectrum_mix_not_set: 'A Light Recipe does not have paired Spectrum Mix',
    target_spectrum_not_exists: 'One of the Light Recipes in the added Recipe is no longer available',
    recipe_not_set: 'Recipe is not set for the Project',
    recipe_not_exists: 'The added Recipe is no longer available',

    // form errors
    this_field_is_required: 'This field is required',
    invalid_number: 'Invalid number',
    the_value_must_be_positive: 'The value must be positive',
    the_value_should_be_minimum_X: 'The value should be minimum {0}',
    the_dmx_channel_is_used: 'The DMX channel is used',
    the_value_should_be_maximum_X: 'The value should be minimum {0}',
    the_name_should_be_unique_X_is_already_used: 'The name should be unique. {0} is already used.',

    settings: 'Settings',
    settings_description: 'Application settings and update',
    group_settings: 'Settings',
    update_to_version: 'Update to version {0}',
    update_in_progress: '{0}%, {1}kb/sec, ETA: {2}s',
    update_downloaded: 'Update is downloaded.',
    installing_update: 'Installing update...\nIt can take several minutes.\nDo not refresh the page.',
    restoring_database: 'Restoring database...',
    no_update_available: 'No update available',
    searching_for_update: 'Searching for update...',
    enable_nightly_build_installs: 'Enable Nightly build installs',
    application_version: 'Application version: {0}',
    offline_mode: 'Offline Mode',
    offline_mode_description: 'Disables online features and allows manual system clock configuration.',
    offline_mode_online_warning: 'Not recommended to enable offline mode when the device has an active internet connection.',
    offline_mode_enabled: 'Enable offline mode',
    set_date_and_time: 'Set Date and Time',
    set_date_and_time_description: 'Manually set the system clock.',
    set_date_and_time_cta: 'Set Date and Time',
    date_time_set: 'Date and time set to {0} {1}',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    second: 'Second',
    am_pm: 'AM/PM',
    serial_number: 'Serial number',
    device_name: 'Device Name',
    device_name_description: 'A human-readable label for this device.',
    device_name_label: 'Device Name',
    device_name_rename: 'Rename the device',
    device_name_saved: 'Device name saved',
    restart_server_app: 'Restart Server Application',
    restart_server_app_description: 'Restart the Ledium MEC server process. The page will automatically reload once the server is back online.',
    restart_server_app_button: 'Restart',
    restart_server_app_confirm: 'Are you sure you want to restart the server application?',
    restarting_server_app: 'Restarting...\nIt can take a moment.\nDo not refresh the page.',
    software_update: 'Software Update',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    password_incorrect: 'The current password is incorrect',
    password_changed: 'The password is changed',
    wifi_ap_settings: 'WiFi Access Point Settings',
    wifi_ap_ssid: 'SSID',
    wifi_ap_passphrase: 'Passphrase',
    wifi_ap_updated: 'WiFi AP settings updated',
    wifi_ap_ssid_invalid: 'SSID must be 1–32 characters (letters, digits, spaces, - . _)',
    wifi_ap_passphrase_invalid: 'Passphrase must be 8–63 characters (letters, digits, common symbols)',
    reboot: 'Reboot',
    shutdown: 'Shutdown',
    reboot_confirm: 'Are you sure you want to reboot the device?',
    shutdown_confirm: 'Are you sure you want to shut down the device?',
    power_management: 'Power Management',
    helper_unavailable_warning:
        'Some features are unavailable because a required system component is not installed on this device. The sections marked below have been disabled.',
    server_offline_warning: 'The device has no internet connection. The sections marked below have been disabled.',
    power_management_description: 'Reboot or shut down the device. The system will gracefully stop all running processes before executing the command.',
    rebooting: 'Device is rebooting...',
    shutting_down: 'Device is shutting down...',
    software_update_description: 'Check for and install application updates. The device must have internet access to search for new versions.',
    change_password_description: 'Change the password for your account.',
    export_database: 'Export Database',
    export_database_description: 'Download a zip archive of all database files for backup or migration purposes.',
    export_database_download: 'Download Database Export',
    import_database: 'Import Database',
    import_database_description:
        'Restore database files from a previously exported zip archive. All running projects will be stopped and the current data will be overwritten.',
    import_database_drop_or_select: 'Drag & drop a database export .zip here, or click to select',
    import_database_upload: 'Import',
    import_database_success: 'Database imported successfully',
    import_database_error_no_file: 'No file selected',
    import_database_error_missing_checksum: 'The file does not contain a checksum',
    import_database_error_hash_mismatch: 'File integrity check failed — the file may be corrupted or was not exported by this application',
    import_database_error_invalid_filename: 'Invalid filename — please use a file exported by this application',
    import_database_error_invalid_zip_contents: 'Invalid database archive - checksum validation failed',
    import_database_error_unknown: 'Import failed',
    cloud_backup: 'Cloud Backup',
    cloud_backup_description:
        'If enabled, your data will be automatically saved to the cloud every hour. You can restore a saved backup from the Cloud Import menu.',
    cloud_backup_enabled: 'Enable cloud backup',
    cloud_restore: 'Cloud Restore',
    cloud_restore_description: 'Load a previously saved backup from the cloud.',
    cloud_restore_open: 'Open Cloud Backup',
    cloud_restore_no_backups: 'No backups found.',
    cloud_restore_col_version: 'Version',
    cloud_restore_col_date: 'Date',
    cloud_restore_cta: 'Restore backup',
    cloud_restore_version_mismatch: 'Different version than current',
    cloud_restore_confirm_title: 'Restore backup',
    cloud_restore_confirm_message: 'Are you sure you want to restore the backup from version {0} saved on {1}? This will overwrite your current data.',
    wifi_ap_settings_description: 'Configure the built-in WiFi access point. Changes take effect immediately and will reconnect all WiFi clients.',
    tab_application: 'Application',
    tab_backup: 'Backup',
    tab_user: 'User',
    tab_system: 'System',

    date_and_time: 'Date and Time',
    date_and_time_description: 'Configure how dates and times are displayed throughout the application.',
    date_format: 'Date format',
    date_format_ymd: 'YYYY-MM-DD',
    date_format_mdy: 'MM/DD/YYYY',
    date_format_dmy: 'DD/MM/YYYY',
    time_format: 'Time format',
    time_format_24: '24-hour clock',
    time_format_12: '12-hour clock (AM/PM)',
    save_changes: 'Save changes',
    date_time_format_saved: 'Date and time format saved',

    groups_title: 'Groups',
    group: 'Group',
    groups_description: 'Groups for Lighting Devices, like rooms, containers, etc',
    no_group: 'You do not have any Groups now',
    search_for_group: 'Search for Groups',
    group_of_the_lighting_device: 'Group of the Lighting Device:',
    select_group_of_the_lighting_devices: 'Select group of the Lighting Devices for this Spectrum Mix',
    select_group_of_the_spectrum_mixes: 'Select group of the Spectrum Mixes for this Project',
    spectrum_mixer_disabled_tree_selection: 'A Lighting Device is selected, group switching is not possible.',
    project_editor_disabled_tree_selection: 'A Spectrum Mix is assigned, group switching is not possible.',
    spectrum_mixer_no_light_in_group: 'No Lighting Device is added to the selected Group.',
    parent_group: 'Parent group:',
    light_channel_group: 'Group: {0}'
};
